// extracted by mini-css-extract-plugin
export default {"container":"ModalFormWindow_container__YZa+J","header":"ModalFormWindow_header__XAceh"};